import React, { useState } from "react";
import { useParams } from 'react-router-dom'
import { getApi } from '../../api/endpoints';
import ListingComponent from '../../components/ListingComponent';
import PAGES from "../../data/PagesConstants";

const Index = () => {
  const params = useParams();
  const defaultHeaderConfig = { disableSort: false };
  const [cvs, setCvs] = useState({});
  const [cvListing] = getApi('chargingVerifications');

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'RMN',
      value: (row) => {
        return <div>
          {!cvs[row.id] && <a className="click-here" href="#" onClick={onGetRmnClick} data-id={ row.id }>Click Here</a>}
          { cvs[row.id] && cvs[row.id].length > 0 && cvs[row.id][0].mobile_number }
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Offer',
      attr: 'offer_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Circle',
      attr: 'branch_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Activation Date',
      attr: 'activated_at',
      disableSort: false
    },
  ]

  const onGetRmnClick = async (e) => {
    e.preventDefault();
    const id = e.target.dataset['id'];
    try {
      const response = await cvListing({user_id: id}).unwrap();
      const charging_verifications = response.data.charging_verifications
      const userCvs = { [id]: charging_verifications };
      setCvs({...cvs, ...userCvs});
    } catch(error) {
      
    }
  }

  return <>
    <ListingComponent
      key={PAGES.FleetOwnerCustomersListing.name}
      listingMutation={getApi('customers')}
      className="customers-listing-page"
      contentHeading="Customer List - Results"
      headers={headers}
      recordsKey="customers"
      params={ {filters: {fleet_owner_id: params.id}} }
      searchBy={['RMN', 'Name']}
    />
  </>
};

export default Index;
